<template>
  <div>
    <a-dropdown>
      <a class="ant-dropdown-link" href="#">
        <a-avatar :src="userData.avatar?userData.avatar:'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png'" />
        {{this.userData.name}}
      </a>
      <a-menu slot="overlay">
        <a-menu-item key="2" @click="modifyUserInfo">
          <a-icon type="user" />个人中心
        </a-menu-item>
        <a-menu-item @click="logout" key="3">
          <a-icon type="login" />退出
        </a-menu-item>
      </a-menu>
    </a-dropdown>
    <hp-manager-modal width="400px" title="修改个人信息" v-model="modifyUserInfoVisible">
      <hp-manager-page-user-info-modify slot="slot" @cancel="modifyUserInfoVisible = false"></hp-manager-page-user-info-modify>
    </hp-manager-modal>
  </div>
</template>
<script>
import { api } from "@/common";
import account from "@/mixins/account";
import hpManagerPageUserInfoModify from "./userSetting";
export default {
  mixins: [account],
  components: {
    hpManagerPageUserInfoModify
  },
  name: "hp-header-user",
  data() {
    return {
      modifyUserInfoVisible: false
    };
  },
  mounted() {},
  methods: {
    modifyUserInfo() {
      this.modifyUserInfoVisible = true;
    },
    async logout() {
      await api.loginOut();
      sessionStorage.clear();
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style  >
</style>




// WEBPACK FOOTER //
// src/components/navigation/user.vue